(() => {
  const sync = (event) => {
    const id = event?.detail?.variant?.id || document.querySelector('.main-product-section form[id^="product-form-"] input[name="id"]')?.value;
    if (!id) return;
    document.querySelectorAll('[data-han-variant-region]').forEach(region => {
      const template = region.querySelector(`template[data-han-variant="${CSS.escape(String(id))}"]`);
      const content = region.querySelector('[data-han-variant-content]');
      if (!template || !content || String(id) === region.dataset.currentVariant) return;
      content.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      region.dataset.currentVariant = String(id);
    });
  };
  const orderGallery = event => {
    const mediaId = event?.detail?.variant?.featured_media?.id;
    if (!mediaId) return;
    document.querySelectorAll('.main-product-section .product__media-list[data-han-lifestyle-first="true"][data-gallery-type="static_column_aside"]').forEach(list => {
      const items = [...list.children].filter(item => item.dataset.mediaId);
      const selected = items.find(item => item.dataset.mediaId.endsWith('-' + mediaId));
      if (!selected) return;
      const lifestyle = items.filter(item => item !== selected && item.dataset.hanLifestyle === 'true');
      const editorial = items.filter(item => item !== selected && item.dataset.hanLifestyle !== 'true' && item.dataset.hanMediaKind === 'editorial');
      const others = items.filter(item => item !== selected && item.dataset.hanLifestyle !== 'true' && item.dataset.hanMediaKind !== 'editorial');
      [selected, ...lifestyle, ...editorial, ...others].forEach(item => list.append(item));
    });
  };
  document.addEventListener('variant:change', event => { orderGallery(event); setTimeout(() => orderGallery(event), 150); });
  document.addEventListener('variant:change', sync);
  document.addEventListener('change', () => { sync(); setTimeout(sync, 150); setTimeout(sync, 500); });
  document.addEventListener('shopify:section:load', sync);
})();

// Keep Han's gallery navigation attached to the native media list and its variant ordering.
function initialiseHanGalleryControls(root = document) {
  root.querySelectorAll('[data-han-gallery-controls]').forEach(controls => {
    if (controls.dataset.ready || controls.querySelector('[data-han-gallery-steps]')) return;
    const gallery = controls.closest('.product__main')?.querySelector('.product__media-list[data-han-lifestyle-first]');
    if (!gallery) return;
    controls.dataset.ready = 'true';
    const items = () => [...gallery.children].filter(item => item.classList.contains('product__media-item'));
    const current = () => {
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const position = mobile ? gallery.scrollLeft : gallery.scrollTop;
      const extent = mobile ? gallery.clientWidth : gallery.clientHeight;
      return Math.min(items().length - 1, Math.max(0, Math.round(position / Math.max(1, extent))));
    };
    controls.querySelectorAll('[data-han-gallery-step]').forEach(button => button.addEventListener('click', () => {
      const index = Math.max(0, Math.min(items().length - 1, current() + Number(button.dataset.hanGalleryStep)));
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      gallery.scrollTo({left: mobile ? index * gallery.clientWidth : 0, top: mobile ? 0 : index * gallery.clientHeight, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    const update = () => {
      const index = current();
      controls.querySelector('[data-han-gallery-index]').textContent = String(index + 1);
      const caption = controls.querySelector('.han-gallery-caption');
      if (caption) caption.textContent = items()[index]?.querySelector('img')?.alt || 'Product photography';
      controls.querySelector('[data-han-gallery-step="-1"]').disabled = index <= 0;
      controls.querySelector('[data-han-gallery-step="1"]').disabled = index >= items().length - 1;
    };
    gallery.addEventListener('scroll', update, {passive: true});
    update();
  });
}
initialiseHanGalleryControls();
document.addEventListener('shopify:section:load', event => initialiseHanGalleryControls(event.target));

(() => {
  if (window.__hanVariantThumbnails) return;
  window.__hanVariantThumbnails = true;
  const cache = new Map();
  let domReady = document.readyState === 'complete';
  const style = document.createElement('style');
  style.textContent = `
    pl-variant-swatches.han-use-native-picker {display:none!important;}
    variant-radios.han-native-colour-picker {display:block!important;}
    variant-radios.han-native-colour-picker .product-form__controls-group {display:flex!important;flex-wrap:wrap;gap:10px;}
    pl-variant-swatches label.han-variant-thumbnail .pl-variant-swatches__swatch-wrapper,
    pl-variant-swatches label.han-variant-thumbnail .pl-variant-swatches__swatch {
      width:64px!important;height:78px!important;min-width:64px!important;padding:0!important;
      border-radius:10px!important;position:relative;overflow:hidden;background:#fff!important;
    }
    pl-variant-swatches label.han-variant-thumbnail .pl-variant-swatches__text {
      position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;
      clip-path:inset(50%)!important;white-space:nowrap!important;
    }
    pl-variant-swatches .han-variant-thumbnail img {display:block;width:100%;height:100%;object-fit:contain;}
    pl-variant-swatches input:checked + label.han-variant-thumbnail .pl-variant-swatches__swatch-wrapper {outline:2px solid #202020;outline-offset:1px;}
    pl-variant-swatches input:focus-visible + label.han-variant-thumbnail {outline:2px solid currentColor;outline-offset:4px;}
    pl-variant-swatches label.han-variant-thumbnail[data-out-of-stock="true"] img {opacity:.45;}
    pl-variant-swatches label.han-variant-thumbnail[data-out-of-stock="true"] .pl-variant-swatches__swatch::after {
      content:'';position:absolute;left:0;top:50%;width:100%;height:1px;background:#555;transform:rotate(-45deg);
    }
  `;
  document.head.append(style);
  function productFor(root) {
    const path = root.dataset.productUrl;
    if (!path) return Promise.resolve(null);
    if (!cache.has(path)) {
      const url = new URL(path, location.href);
      if (url.origin !== location.origin) return Promise.resolve(null);
      cache.set(path, fetch(url.pathname.replace(/\/$/, '') + '.js', {credentials:'same-origin'})
        .then(response => response.ok ? response.json() : null).catch(() => null));
    }
    return cache.get(path);
  }
  async function enhance(root) {
    if (!domReady) return;
    const native = document.getElementById('variant-radios-' + root.dataset.sectionId);
    if (!customElements.get('pl-variant-swatches') && native?.querySelector('input[type="radio"]')) {
      native.classList.add('han-native-colour-picker');
      root.classList.add('han-use-native-picker');
      return;
    }
    const product = await productFor(root);
    if (!product || !root.isConnected) return;
    const options = product.options.map(option => typeof option === 'string' ? option : option.name);
    const radios = [...root.querySelectorAll('input.pl-variant-swatches__radio')];
    const selected = options.map(name => radios.find(input => input.dataset.optionName === name && input.checked)?.value);
    radios.forEach(input => {
      if (!/^(colour|color)$/i.test(input.dataset.optionName?.trim() || '')) return;
      const label = input.nextElementSibling;
      const surface = label?.querySelector('.pl-variant-swatches__swatch');
      if (!surface) return;
      const index = options.indexOf(input.dataset.optionName);
      if (index < 0) return;
      const candidates = product.variants.filter(variant => variant.options[index] === input.value && variant.featured_image?.src);
      const variant = candidates.find(variant => selected.every((value, i) => i === index || !value || variant.options[i] === value)) || candidates[0];
      if (!variant) return;
      const url = new URL(variant.featured_image.src, location.href);
      url.searchParams.set('width', '160');
      let image = surface.querySelector('img[data-han-variant-thumbnail]');
      if (!image) {
        image = document.createElement('img');
        image.dataset.hanVariantThumbnail = '';
        image.alt = '';
        image.hidden = true;
        image.setAttribute('aria-hidden', 'true');
        image.onload = () => {
          image.hidden = false;
          label.classList.add('han-variant-thumbnail');
          label.title = input.getAttribute('aria-label') || input.value;
        };
        image.onerror = () => {
          image.hidden = true;
          label.classList.remove('han-variant-thumbnail');
        };
        surface.append(image);
      }
      if (image.src !== url.href) image.src = url.href;
    });
  }
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll('pl-variant-swatches').forEach(enhance);
    });
  }
  document.addEventListener('DOMContentLoaded', () => { domReady = true; schedule(); }, {once:true});
  window.addEventListener('load', () => { domReady = true; schedule(); }, {once:true});
  customElements.whenDefined('pl-variant-swatches').then(() => {
    document.querySelectorAll('.han-use-native-picker').forEach(root => root.classList.remove('han-use-native-picker'));
    document.querySelectorAll('.han-native-colour-picker').forEach(root => root.classList.remove('han-native-colour-picker'));
    schedule();
  });
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('change', event => { if (event.target.closest('pl-variant-swatches')) schedule(); });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
